import { APIMethod, fetchData } from "@client";

export async function changeLibraryWorkTypeQuery(oldElementId, newElementId) {
  await fetchData(`/v1/library/worktype/${oldElementId}`, APIMethod.PATCH, {
    data: { newWorkType: newElementId },
  });
}
